"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getPlannerProgressService($plannerType: String, $lotNumber: String) {
        planner {
            activeDate
            plannerId
            plannerSections {
                nodes {
                    name
                    plannerSectionId
                    sectionContents {
                        nodes {
                            content {
                                contentType
                                tag
                                completedContents {
                                    nodes {
                                        content {
                                            contentType
                                            tag
                                            contentId
                                        }
                                        contentId
                                    }
                                }
                            }
                            contentId
                        }
                    }
                }
            }
            version
        }
        UserProfile {
            plannerProgress(plannerType: $plannerType, lotNumber: $lotNumber) {
                nodes {
                    section
                    completed
                    total
                    percentCompleted
                }
            }
        }
    }
`;exports.getPlannerProgress=e;
//# sourceMappingURL=queries.js.map
